<div *ngIf="!isEdit && !reviewFlag">
  <i *ngIf="productOpen" (click)="toggleProduct()" class="material-icons right">
    keyboard_arrow_up
  </i>
  <i
    *ngIf="!productOpen"
    (click)="toggleProduct()"
    class="material-icons right"
  >
    keyboard_arrow_down
  </i>
</div>
<div class="space-div" *ngIf="isEdit" [ngClass]="isEdit ? 'isEdit' : ''"></div>
<div class="row rfq-list-view" [ngClass]="isEdit ? 'isEdit' : ''">
  <div class="col-md-2">
    <div class="vs-checkbox float-left select-product-check">
      <input
        [id]="'cart-entry-' + entryNum"
        type="checkbox"
        value="true"
        [checked]="checkAll"
        [name]="'cart-entry-' + entryNum"
        (click)="checkEntry($event)"
      />
      <label [for]="'cart-entry-' + entryNum" class="cart-item-check"></label>
    </div>
    <div class="number float-left">{{ product.entryNumber + 1 }}</div>
    <div class="cx-image-container">
      <a [routerLink]="['/product',product?.product.code, product?.product.name]" tabindex="-1">
        <cx-media
          class="rfqSearchTumbnail thumbnail"
          [container]="product.product.images"
          [alt]="product.summary"
        >
        </cx-media>
      </a>
    </div>
  </div>
  <div class="col-md-3 left-window">
    <div class="vs-text-field">
      <label class="prod_top heading-label">{{ "quoteCart.prodTopHeading" | cxTranslate }}</label>
      <div class="bold" *ngIf="!isEdit && !product.isCatalogItem">
        {{ product.rfqPartNumber }}
      </div>
      <a 
      [routerLink]="['/product',product?.product.code, product?.product.name]"
        class="prod_numb bold"
        *ngIf="product.isCatalogItem"
      >
        {{ product.rfqPartNumber }}
      </a>
      <input
        *ngIf="isEdit && !product.isCatalogItem"
        class="vs-text-field"
        type="text"
        placeholder='{{ "quoteCart.partPlaceholder" | cxTranslate }}'
        [(ngModel)]="editProduct.rfqPartNumber"
      />
    </div>

    <div class="vs-text-field">
      <label class="prod_top heading-label">{{ "quoteCart.partDescription" | cxTranslate }}</label>

      @if ((isEdit && product.isCatalogItem) || !isEdit) {
        @if (product.rfqPartDescription) {
          <div
            class="bold product-data-text">
            {{ product.rfqPartDescription }}
          </div>
        } @else {
          <div class="bold product-data-text">
            {{ editProduct?.product?.partDescription }}
          </div>
        }
      }

      @if (isEdit && !product.isCatalogItem) {
        @if (editProduct.rfqPartDescription) {
          <input
            class="vs-text-field"
            type="text"
            placeholder='{{ "quoteCart.partDescription2" | cxTranslate }}'
            [(ngModel)]="editProduct.rfqPartDescription"
            maxlength="40"
          />
        } @else {
          <input
            class="vs-text-field"
            type="text"
            placeholder='{{ "quoteCart.partDescription2" | cxTranslate }}'
            [(ngModel)]="editProduct.product.partDescription"
            maxlength="40"
          />
        }
      }
    </div>

    <div *ngIf="isEdit || productOpen" class="dropdown-container prod_top">
      <label class="heading-label">{{
        "quoteCart.brandLabel" | cxTranslate
      }}</label>
      <div *ngIf="(product.isCatalogItem || !isEdit) && (product.brandName !='' || product.brandName != null)" class="product-data-text">
        {{ product.brandName }}
      </div>
      <div *ngIf="(product.isCatalogItem || !isEdit) && (product.brandName == '' || product.brandName == null)" class="product-data-text">
        {{
          "quoteCart.Masoneilan" | cxTranslate
        }}
      </div>
      <!-- <select *ngIf="!product.isCatalogItem && isEdit" [(ngModel)]="editProduct.brandName" id="brand" [ngClass]="equipment ? 'border-danger':''">
        <option value="" disabled selected hidden>Select Brand</option>
        <option value="Masoneilan">Masoneilan</option>
        <option value="Consolidated">Consolidated</option>
        <option vakue="Becker">Becker</option>
        <option value="Mooney">Mooney</option>
      </select> -->
      <ng-select
        [searchable]="false"
        [clearable]="false"
        placeholder='{{ "quoteCart.selectPlaceholder" | cxTranslate }}'
        *ngIf="!product.isCatalogItem && isEdit"
        [(ngModel)]="editProduct.brandName"
        id="brand"
        [ngClass]="equipment ? 'border-danger' : ''"
      >
        ><ng-option value="" ng-selected="selected" hidden disabled>
          {{ "quoteCart.brandSelect" | cxTranslate }}
        </ng-option>
        <ng-option *ngFor="let brand of this.brands" [value]="brand.code">
          {{ brand.name }}
        </ng-option>
      </ng-select>
    </div>

    <div
      class="vs-text-field"
      *ngIf="
        (isEdit || productOpen) &&
        checkSerialNoDisplayLogic(productType, editProduct)
      "
    >
      <label
        class="prod_top heading-label"
        *ngIf="
          editProduct?.serialNumber ||
          (checkSerialNoDisplayLogic(productType, editProduct) && isEdit)
        "
        >{{ "quoteCart.serialNumberLabel" | cxTranslate }}</label
      >
      <input
        type="text"
        *ngIf="
          (isEdit && !product.isCatalogItem) ||
            (isEdit &&
              product.isCatalogItem &&
              checkSerialNoDisplayLogic(productType, editProduct));
          else showReadonly
        "
        [(ngModel)]="editProduct.serialNumber"
        maxlength="200"
      />
      <label *ngIf="!editProduct.serialNumber && serialNumFlag" class="error">{{ "quoteCart.selectSerialNumError" | cxTranslate }}</label>
      <ng-template #showReadonly>
        <div
          class="bold product-data-text"
          [innerHTML]="product.serialNumber"
        ></div
      ></ng-template>
    </div>
    <!-- <div class="vs-text-field" *ngIf="isEdit || productOpen && reviewFlag != 'true'? true: false"> -->
    <div class="vs-text-field" *ngIf="isEdit || productOpen">
      <label class="prod_top heading-label">{{
        "quoteCart.tagNumberLabel" | cxTranslate
      }}</label>
      <input
        type="text"
        *ngIf="isEdit"
        [(ngModel)]="editProduct.tagNumber"
        maxlength="35"
      />
      <div class="bold product-data-text" *ngIf="!isEdit">
        {{ product.tagNumber }}
      </div>
    </div>

    <!-- Material Number Input -->
    <div class="matnum-input-container">
      <label>{{ 'quoteCart.materialNumber' | cxTranslate }}</label>
      <input
        class="matnum-input"
        id="matnum"
        type="text"
        minlength="3"
        maxlength="25"
        [(ngModel)]="editProduct.customerMaterialNumber"
        [ngClass]="product?.quoteCartEntryType == QuoteStatus.EDIT ? 'disabled' : ''"
        placeholder="{{
          'quoteCart.materialNumberPlaceholder' | cxTranslate
        }}"
      />
      <div
        class="save-material-num"
        (mousedown)="onSaveMaterialNumMouseDown($event)"
        (click)="materialInputChanges()"
        *ngIf="!savingMaterialNum"
        [ngClass]="product?.quoteCartEntryType == QuoteStatus.EDIT ? 'disabled' : ''"
      >
        <i class="material-icons ml-0">save</i>
      </div>

      <span class="saving-matnum-txt" *ngIf="savingMaterialNum">{{
        'quoteCart.saveComments' | cxTranslate
      }}</span>
    </div>

    <div class="comment-container" *ngIf="reviewFlag != 'true' ? true : false">
      <a
        (click)="toggleComment()"
        *ngIf="!commentOpen && product?.quoteCartEntryType != QuoteStatus.EDIT"
        class="comments-text"
      >
        <i class="material-icons plus">add</i>
        {{ "quoteCart.additionalComments" | cxTranslate }}</a
      >
      <a
        (click)="toggleComment()"
        *ngIf="!commentOpen && product?.quoteCartEntryType == QuoteStatus.EDIT"
        class="comments-text disabled"
      >
        <i class="material-icons plus">add</i>
        {{ "quoteCart.additionalComments" | cxTranslate }}</a
      >
      <a
        (click)="toggleComment()"
        *ngIf="commentOpen"
        [ngClass]="
          product?.quoteCartEntryType == QuoteStatus.EDIT ? 'disabled' : ''
        "
      >
        <i class="material-icons plus">remove</i>
        {{ "quoteCart.additionalComments" | cxTranslate }}</a
      >
      <div class="vs-text-area" *ngIf="commentOpen">
        <textarea
          [(ngModel)]="editProduct.comment"
          (input)="commentError = false"
          maxlength="255"
          [class.error]="
            (commentError && editProduct.comment?.length <= 0) ||
            (showCommentsNotSavedErr && editProduct.comment?.length > 0)
          "
          [ngClass]="
            product?.quoteCartEntryType == QuoteStatus.EDIT ? 'disabled' : ''
          "
          (blur)="onCommentsInputBlur($event)"
          >{{ product.comment }}</textarea
        >
        <label
          *ngIf="commentError && editProduct.comment?.length <= 0"
          class="error"
          >{{ "quoteCart.commentError" | cxTranslate }}</label
        >
        <label
          *ngIf="showCommentsNotSavedErr && editProduct.comment?.length > 0"
          class="error"
        >
        {{ "quoteCart.commentError2" | cxTranslate }}
          {{ showCommentsNotSavedErr }}
        </label>
        <div class="comments-action-holder mt-1 pl-0">
          <a
            *ngIf="!savingComments"
            class="comment-save-custom"
            [ngClass]="
              product?.quoteCartEntryType == QuoteStatus.EDIT ? 'disabled' : ''
            "
            (mousedown)="onSaveCommentsMouseDown($event)"
            (click)="commentUpdated()"
          >
            <em class="material-icons ml-0 save-icon">save</em>
          </a>
          <span class="char-limit" *ngIf="savingComments">{{ "quoteCart.saveComments" | cxTranslate }}</span>
          <label class="char-limit char-limit-count"
            >{{ "quoteCart.charLeft" | cxTranslate }} : {{ 255 - editProduct.comment?.length }}</label
          >
        </div>
      </div>
    </div>

    <div
      class="comment-container"
      *ngIf="(reviewFlag == 'true' ? true : false) && editProduct.comment"
    >
      <div>{{ "quoteCart.additionalComments" | cxTranslate }}</div>
      <div class="bold">{{ editProduct.comment }}</div>
    </div>
  </div>
  <div class="col-md-2" *ngIf="!reviewFlag">
    <div class="bold float-left qty-text">
      {{ "quoteCart.quantity" | cxTranslate }}
    </div>
    <vs-item-counter
      class="float-left disabled"
      [control]="quantity"
      [max]="9999"
      *ngIf="product?.quoteCartEntryType == QuoteStatus.EDIT"
    ></vs-item-counter>
    <vs-item-counter
      class="float-left"
      [control]="quantity"
      [max]="9999"
      *ngIf="product?.quoteCartEntryType != QuoteStatus.EDIT"
    ></vs-item-counter>
    <div class="each-text float-left" *ngIf="product.isCatalogItem">
      {{ product.salesUnit }}
    </div>
  </div>
  <div class="col-md-2 bold" *ngIf="reviewFlag">
    {{ product.quantity }} {{ product.salesUnit }}
  </div>

  <div class="col-md-2 quantity-column">
    <div>
      <div class="mb-4">
        <div class="heading-label">
          {{ "quoteCart.listPrice" | cxTranslate }}
        </div>
        <span
          class="bold product-data-text"
          *ngIf="
            product?.totalPrice?.value &&
            userType == 'current' &&
            (product.isCatalogItem ||
              (!product.isCatalogItem &&
                product?.quoteCartEntryType == QuoteStatus.EDIT &&
                product?.totalPrice?.value > 0)) &&
            !product?.product?.obsoleteProductFlag
          "
          >{{ product?.basePrice?.currencyIso }}
          {{ product?.basePrice?.formattedValue }}</span
        >
        <p
          *ngIf="
            !product?.totalPrice?.value ||
            userType == 'anonymous' ||
            (!product.isCatalogItem &&
              product?.quoteCartEntryType != QuoteStatus.EDIT) ||
            product?.product?.obsoleteProductFlag ||
            product?.netPrice?.value == 0
          "
          class="bold"
        >
          {{ "quoteCart.toBeQuoted" | cxTranslate }}
        </p>
      </div>
      <div>
        <span
          >{{ "quoteCart.unitPrice" | cxTranslate }}
          <!-- <i *ngIf="userType == 'anonymous' || !product.isCatalogItem || product?.product?.obsoleteProductFlag" class="material-icons help" matTooltipClass="vs-tooltip"
            matTooltip="No price available">
            info
          </i> -->
          <a
            *ngIf="
              product?.netPrice?.formattedValue &&
              userType === 'current' &&
              (product.isCatalogItem ||
                (!product.isCatalogItem &&
                  product?.quoteCartEntryType != QuoteStatus.EDIT)) &&
              !product?.product?.obsoleteProductFlag &&
              (product?.discountDetails.length > 0 || product?.afterMarket?.formattedValue)
            "
            (click)="openViewBreakup()"
            class="breakup-link arw"
            >{{ "quoteCart.viewBreakup" | cxTranslate
            }}<i *ngIf="!breakUp" class="material-icons">keyboard_arrow_down</i>
            <i *ngIf="breakUp" class="material-icons"
              >keyboard_arrow_right</i
            ></a
          ></span
        >
        <span
          *ngIf="
            product?.netPrice?.value > 0 &&
            userType === 'current' &&
            (product.isCatalogItem ||
              (!product.isCatalogItem &&
                product?.quoteCartEntryType == QuoteStatus.EDIT &&
                product?.netPrice?.value > 0)) &&
            !product?.product?.obsoleteProductFlag
          "
          class="bold d-block"
          >{{ product?.netPrice?.currencyIso }}
          {{ product?.netPrice?.formattedValue }}</span
        >
        <span
          class="d-block bold"
          *ngIf="
            !product?.netPrice?.value ||
            userType === 'anonymous' ||
            (!product.isCatalogItem &&
              product?.quoteCartEntryType != QuoteStatus.EDIT) ||
            product?.product?.obsoleteProductFlag ||
            product?.netPrice?.value == 0
          "
          >{{ "quoteCart.toBeQuoted" | cxTranslate }}</span
        >
      </div>
      <div
        class="breakup-dropdown"
        *ngIf="breakUp"
        (clickOutside)="closeMenu($event)"
        [exclude]="'a,.arw'"
      >
        <div class="row list-price-row m-0">
          <span class="price-menu-heading bold col-6">{{ "quoteCart.listPrice" | cxTranslate }}</span>
          <span class="price-menu-content bold col-6"
            >{{ product?.basePrice?.currencyIso }}
            {{ product?.basePrice?.formattedValue }}</span
          >
        </div>
        <div
          class="row discounts"
          *ngFor="let discounts of product?.discountDetails"
        >
          <span class="price-menu-heading col-6">{{
            getDiscountName(discounts.code)
          }}</span>
          <span class="price-menu-content col-2"
            >{{ discounts.appliedValue | number }}%</span
          >
          <span class="price-menu-content col-4"
            >{{ discounts.currency }} -{{ discounts.formattedValue }}</span
          >
        </div>
		<div
          class="row discounts"
          *ngIf="product.afterMarket && product.afterMarket?.value > -1"
        >
          <span class="price-menu-heading col-6">{{ "quoteCart.afterMarket" | cxTranslate }}</span>
          <span class="price-menu-content col-2"
            >{{ product?.afterMarketPremium | number }}%</span
          >
          <span class="price-menu-content col-4"
            >{{ product.afterMarket?.currencyIso }}
            {{ product.afterMarket?.formattedValue }}</span
          >
        </div>
        <div
          class="row discounts"
          *ngIf="product.expressAdder && product.expressAdder?.value > -1"
        >
          <span class="price-menu-heading col-6">{{ "quoteCart.expressDelivery" | cxTranslate }}</span>
          <span class="price-menu-content col-2"
            >{{ product?.expressAdderPercent | number }}%</span
          >
          <span class="price-menu-content col-4"
            >{{ product.expressAdder?.currencyIso }}
            {{ product.expressAdder?.formattedValue }}</span
          >
        </div>
        <!--Tariff Surcharge div start-->
        <div
          class="row discounts"
          *ngIf="product.tariffCharges && product.tariffCharges?.value > -1"
        >
          <span class="price-menu-heading col-6">{{ "quoteCart.tariffSurcharge" | cxTranslate }}</span>
          <span class="price-menu-content col-2"
            >{{ product?.tariffChargesPercent | number }}%</span
          >
          <span class="price-menu-content col-4"
            >{{ product.tariffCharges?.currencyIso }}
            {{ product.tariffCharges?.formattedValue }}</span
          >
        </div>
        <!--Tariff Surcharge div start-->
        <div
          class="row total-discounts"
          *ngIf="product?.discountDetails.length > 0 || product?.afterMarket?.value > 0"
        >
          <span class="price-menu-heading col-6">{{ "quoteCart.adjustTotal" | cxTranslate }}</span>
          <span class="price-menu-content col-6"
            >{{ product?.totalPrice?.currencyIso }} -
            <!-- {{ getTotalDiscounts(product?.discountDetails) }} -->
              {{(product.basePrice.value - product.netPrice.value)| currency: product.basePrice?.currencyIso:"symbol-narrow"}}
            </span>
        </div>
        <div class="row net-price">
          <span class="price-menu-heading bold col-6">{{ "quoteCart.netPrice" | cxTranslate }}</span>
          <span class="price-menu-content bold col-6"
            >{{ product?.netPrice?.currencyIso }}
            {{ product?.netPrice?.formattedValue }}</span
          >
        </div>
      </div>
      <div class="prod_top">
        <div class="heading-label">
          {{ "quoteCart.extendedPrice" | cxTranslate }}
          <i
            class="material-icons help_custom"
            matTooltipClass="vs-tooltip"
            matTooltip='{{ "quoteCart.unitPriceTooltipTxt" | cxTranslate }}'
          >
            info
          </i>
        </div>
        <span
          class="bold product-data-text"
          *ngIf="
            product?.totalPrice?.value &&
            userType == 'current' &&
            (product.isCatalogItem ||
              (!product.isCatalogItem &&
                product?.quoteCartEntryType == QuoteStatus.EDIT &&
                product?.totalPrice?.value > 0)) &&
            !product?.product?.obsoleteProductFlag
          "
          >{{ product?.totalPrice?.currencyIso }}
          {{
              product?.totalPrice?.value
              | currency: product?.totalPrice?.currencyIso:"symbol-narrow"
          }}</span
        >
	
        <p
          *ngIf="
            !product?.totalPrice?.value ||
            userType == 'anonymous' ||
            (!product.isCatalogItem &&
              product?.quoteCartEntryType != QuoteStatus.EDIT) ||
            product?.product?.obsoleteProductFlag ||
            product?.netPrice?.value == 0
          "
          class="bold"
        >
          {{ "quoteCart.toBeQuoted" | cxTranslate }}
        </p>
      </div>
    </div>
  </div>

  <div class="col-md-3">
    <div class="vs-text-field">
      <label>{{ "quoteCart.customerRequestDateLabel" | cxTranslate }}</label>
      <vs-date-picker
        class="date-picker-quote-product"
        *ngIf="!reviewFlag && product?.quoteCartEntryType != QuoteStatus.EDIT"
        (selectedDate)="dateChange($event)"
        [filterWeekend]="filterWeekend"
        [defaultDate]="product?.customerRequestedDate"
        [min]="minDate"
        [dateInputLabel]="'crd'"
        [selectedEntity]="selectedLegalEntityId"
      >
      </vs-date-picker>
      <vs-date-picker
        class="date-picker-quote-product disabled"
        *ngIf="!reviewFlag && product?.quoteCartEntryType == QuoteStatus.EDIT"
        (selectedDate)="dateChange($event)"
        [filterWeekend]="filterWeekend"
        [defaultDate]="product?.customerRequestedDate"
        [min]="minDate"
        [dateInputLabel]="'crd'"
        [selectedEntity]="selectedLegalEntityId"
      >
      </vs-date-picker>

      <span *ngIf="reviewFlag" class="bold">
        {{ getFormattedDate(product?.customerRequestedDate) }}
      </span>
    </div>

    <!-- Lead Time Start -->
    <div class="available-at-holder">
      <label>Lead Time <span class="required-asterisk">*</span> </label>
      <div class="available-at-dropdown">
        <ng-select
          (change)="onLeadTimeChange($event)"
          class="mb-1"
          [(ngModel)]="product.leadTime"
          [class.disabled]="showAvailabilityLoader"
          [searchable]="false"
          [clearable]="false"
          placeholder='{{ "quoteCart.selectPlaceholder" | cxTranslate }}'
          [ngClass]="
            product.quoteCartEntryType == QuoteStatus.EDIT ? 'disabled' : ''
          "
        >
          <option disabled selected hidden>{{ "quoteCart.selectPlaceholder" | cxTranslate }}</option>
          <ng-option
          *ngFor="let entity of leadTimeOptions; let i = index"
            [value]="entity.delivery_time"
          >
            {{ entity.delivery_time }}
          </ng-option>
        </ng-select>
      </div>
    </div>
    <!-- Lead Time End -->

    <!-- && product?.quoteCartEntryType != QuoteStatus.EDIT -->
    <div
      *ngIf="productOpen && product?.quoteCartEntryType != QuoteStatus.EDIT"
      class="mt10"
    >
      <div>{{ "quoteCart.reasonForQuoteLabel" | cxTranslate }}</div>
      <div *ngIf="!isEdit">
        <div
          class="bold"
          *ngIf="product?.reasonForQuote === undefined && reasonForQuotes"
        >
          <div class="reason-txt">{{ reasonForQuotes[0].name }}</div>
        </div>
        <div *ngIf="product?.reasonForQuote">
          <div class="bold" *ngFor="let reason of reasonForQuotes">
            <div
              class="reason-txt"
              *ngIf="product?.reasonForQuote === reason.code"
            >
              {{ reason?.name }}
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="isEdit">
        <ng-select
          [searchable]="false"
          [clearable]="false"
          placeholder='{{ "quoteCart.selectPlaceholder" | cxTranslate }}'
          class="w-100"
          [(ngModel)]="editProduct.reasonForQuote"
        >
          <ng-option
            *ngFor="let reason of this.reasonForQuotes"
            [value]="reason.code"
            ng-selected="reason.code == this.reasonForQuotes[0].code"
          >
            {{ reason.name }}
          </ng-option>
        </ng-select>
      </div>
    </div>
    <!-- && product?.quoteCartEntryType != QuoteStatus.EDIT -->
    <div
      *ngIf="productOpen && product?.quoteCartEntryType != QuoteStatus.EDIT"
      class="mt10"
    >
      <div>
        {{ "quoteCart.unsolicited" | cxTranslate }}
        <i
          class="material-icons help_custom"
          matTooltipClass="vs-tooltip"
          matTooltip='{{ "quoteCart.quoteTooltipTxt" | cxTranslate }}'
        >
          info
        </i>
      </div>
      <div *ngIf="!isEdit">
        <div class="bold" *ngIf="product.isUnsolicited">
          {{ "quoteCart.yesLabel" | cxTranslate }}
        </div>
        <div class="bold" *ngIf="!product.isUnsolicited">
          {{ "quoteCart.noLabel" | cxTranslate }}
        </div>
      </div>
      <div class="vs-radio-button row" *ngIf="isEdit">
        <div class="col-4">
          <input
            id="isUnsolicited{{ product.entryNumber + 1 }}"
            type="radio"
            [value]="true"
            name="isUnsolicited{{ product.entryNumber + 1 }}"
            [(ngModel)]="editProduct.isUnsolicited"
          />
          <label class="m-0" for="isUnsolicited{{ product.entryNumber + 1 }}">{{
            "quoteCart.yesLabel" | cxTranslate
          }}</label>
        </div>

        <div class="col-4">
          <input
            id="isNotUnsoliced{{ product.entryNumber + 1 }}"
            type="radio"
            [value]="false"
            name="isUnsolicited{{ product.entryNumber + 1 }}"
            [(ngModel)]="editProduct.isUnsolicited"
          />
          <label
            class="m-0"
            for="isNotUnsoliced{{ product.entryNumber + 1 }}"
            >{{ "quoteCart.noLabel" | cxTranslate }}</label
          >
        </div>
      </div>
    </div>
    <!-- Available At -->
    <div
      *ngIf="
        productOpen &&
        product?.plantAvailableAt?.length &&
        product?.quoteCartEntryType != QuoteStatus.EDIT &&
        product.isCatalogItem &&
        userType == 'current' &&
        reviewFlag != 'true'
          ? true
          : false
      "
      class="available-at-holder"
    >
      <label>{{ "quoteCart.shippedFrom" | cxTranslate }}</label>
      <div class="available-at-dropdown">
        <ng-select
          (change)="onLegalEntitySelect($event)"
          class="mb-1"
          [(ngModel)]="availableAt"
          [class.disabled]="showAvailabilityLoader"
          [searchable]="false"
          [clearable]="false"
          placeholder='{{ "quoteCart.selectPlaceholder" | cxTranslate }}'
          [ngClass]="
            product.quoteCartEntryType == QuoteStatus.EDIT ? 'disabled' : ''
          ">
          <option disabled selected hidden>{{ "quoteCart.selectPlaceholder" | cxTranslate }}</option>
          <ng-option
          *ngFor="let entity of shippedFrmOptions; let i = index"
            [value]="entity">
            {{ entity.name }} ({{
              entity?.stockAvailable || 0 | number: "1.0-0"
            }})
          </ng-option>
        </ng-select>
        <label *ngIf="showNotAvailableMsg" class="not-available-warning mt-1">
          <i class="material-icons mr-2">info</i>
          <span class="small-font"
            >{{ "quoteCart.notAvailable" | cxTranslate }}</span
          >
        </label>
      </div>
    </div>
    <!-- Availability Action -->
    <div
      *ngIf="
        productOpen &&
        showCheckAvalabilityAction &&
        product.isCatalogItem &&
        product?.quoteCartEntryType != QuoteStatus.EDIT &&
        userType == 'current'
      "
      class="availability-action-holder"
    >
      <button
        class="vs-tertiary-btn width100"
        (click)="checkAvailability(product)"
        [disabled]="showAvailabilityLoader"
      >
        <span *ngIf="!showAvailabilityLoader">{{ "quoteCart.checkAvailability" | cxTranslate }}</span>
        <div
          *ngIf="showAvailabilityLoader"
          class="availability-spinner cx-spinner"
        >
          <cx-spinner></cx-spinner>
        </div>
      </button>
    </div>

    <!-- Availability Info -->
    <div
      *ngIf="
        productOpen &&
        !showCheckAvalabilityAction &&
        product.isCatalogItem &&
        product?.quoteCartEntryType != QuoteStatus.EDIT &&
        product.availabilityDetail &&
        userType == 'current'
      "
    >
      <div class="small-font mt-15">
        {{ "quoteCart.infoAvailability" | cxTranslate }}
        <div
          *ngFor="
            let availabilityStatus of product.availabilityDetail;
            let i = index
          "
          class="availability-information"
        >
          <div
            class="bold"
            *ngIf="
              dateFormatChange(availabilityStatus?.committedDate) ==
              product?.customerRequestedDate
            "
          >
          {{ "quoteCart.quantityAvailability" | cxTranslate }}
            {{ availabilityStatus.committedQuantity | number: "1.0-0" }}
          </div>

          <div
            *ngIf="
              i == 0 &&
              dateFormatChange(availabilityStatus?.committedDate) !=
                product?.customerRequestedDate
            "
            class="bold early-msg"
          >
          {{ "quoteCart.noStock" | cxTranslate }}
            {{ product?.customerRequestedDate | date: "dd MMMM yyyy" }}
          </div>
          <div
            class="early-msg"
            *ngIf="
              dateFormatChange(availabilityStatus?.committedDate) !=
              product?.customerRequestedDate
            "
          >
          {{ "quoteCart.earlyShipDate" | cxTranslate }}
            {{ availabilityStatus?.committedQuantity | number: "1.0-0" }} is
            {{ availabilityStatus?.committedDate | date: "dd MMMM yyyy" }}
          </div>
        </div>
      </div>
    </div>
    <!-- View Inventory -->
    <div
      *ngIf="productOpen && otherInventoryLocations?.length
      && product?.quoteCartEntryType != QuoteStatus.EDIT &&
      product.isCatalogItem &&
      userType == 'current' &&
      reviewFlag != 'true'
        ? true
        : false
    ">
        <a class="link early-msg view-inventory-text"
          (click)="viewInventory()"
        >{{ "quoteCart.viewInventory" | cxTranslate }}</a>
    </div>
    <div *ngIf="productOpen && !product.isCatalogItem" class="mt10">
      <label class="heading-label label-width-custom">
        {{ "quoteCart.productTypeLabel" | cxTranslate }}
        <i
          class="material-icons help_custom"
          matTooltipClass="vs-tooltip"
          matTooltip='{{
            product.productType | titlecase
          }} {{ "quoteCart.isDefinedTooltipTxt" | cxTranslate }}'
        >
          info
        </i>
      </label>
      <div class="bold product-data-text" *ngIf="!isEdit">
        {{ product?.productType | titlecase }}
      </div>
      <div class="vs-radio-button row" *ngIf="isEdit">
        <div class="col-3">
          <input
            id="EQUIPMENT{{ product.entryNumber + 1 }}"
            type="radio"
            value="EQUIPMENT"
            name="EQUIPMENT{{ product.entryNumber + 1 }}"
            [(ngModel)]="editProduct.productType"
          />
          <label class="m-0" for="EQUIPMENT{{ product.entryNumber + 1 }}">{{
            "quoteCart.productType1" | cxTranslate
          }}</label>
        </div>

        <div class="col-3 ml50">
          <input
            id="PART{{ product.entryNumber + 1 }}"
            type="radio"
            value="PART"
            name="PART{{ product.entryNumber + 1 }}"
            [(ngModel)]="editProduct.productType"
          />
          <label class="m-0" for="PART{{ product.entryNumber + 1 }}">{{
            "quoteCart.productType2" | cxTranslate
          }}</label>
        </div>
      </div>
      <label *ngIf="(!product.productType || product.productType == '' || product.productType == null) && !editProduct.productType" class="error">{{ "quoteCart.productTypeSelect" | cxTranslate }}</label>
      <div class="col-md-1"></div>
    </div>
  </div>
</div>

<div class="row bdr-btm" *ngIf="!isEdit && reviewFlag != 'true' ? true : false">
  <div class="col-md-8"></div>
  <div class="col-md-4 text-center m-b-10 p-0">
    <div class="action-row">
      <div>
        <a
          *ngIf="product?.quoteCartEntryType == QuoteStatus.EDIT"
          class="link editlink disabled"
          >{{ "quoteCart.splitByQuantity" | cxTranslate }}</a
        >
        <a
          *ngIf="product?.quoteCartEntryType != QuoteStatus.EDIT"
          (click)="splitQuoteItem()"
          class="link editlink"
          [ngClass]="(product.quantity <= 1 )? 'disabled' : ''"
          >{{ "quoteCart.splitByQuantity" | cxTranslate }}</a
        >
      </div>

      <div>
        <a
          *ngIf="product?.quoteCartEntryType == QuoteStatus.EDIT"
          class="link disabled"
          >{{ "quoteCart.duplicate" | cxTranslate }}</a
        >
        <a
          *ngIf="product?.quoteCartEntryType != QuoteStatus.EDIT"
          (click)="duplicateProduct()"
          class="link"
          >{{ "quoteCart.duplicate" | cxTranslate }}</a
        >
      </div>
      <div>
        <a
          *ngIf="product?.quoteCartEntryType == QuoteStatus.EDIT"
          class="link editlink disabled"
          >{{ "quoteCart.edit" | cxTranslate }}</a
        >
        <a
          *ngIf="product?.quoteCartEntryType != QuoteStatus.EDIT"
          (click)="edit()"
          class="link editlink"
          >{{ "quoteCart.edit" | cxTranslate }}</a
        >
      </div>
      <div>
        <a
          *ngIf="product?.quoteCartEntryType == QuoteStatus.EDIT"
          class="link disabled"
          >{{ "quoteCart.delete" | cxTranslate }}</a
        >
        <a
          *ngIf="product?.quoteCartEntryType != QuoteStatus.EDIT"
          (click)="openDeletePopUp()"
          class="link"
          >{{ "quoteCart.delete" | cxTranslate }}</a
        >
      </div>
    </div>
  </div>
</div>
<div class="row bdr-btm" *ngIf="reviewFlag"></div>

<div class="row bdr-btm" *ngIf="isEdit" [ngClass]="isEdit ? 'isEdit' : ''">
  <div class="col-md-9"></div>
  <div class="col-md-3 text-center m-t-10 m-b-10">
    <div class="row float-right">
      <div class="col-md-4 cancel-btn-holder">
        <button class="link editlink vs-text-btn cancel" (click)="cancel()">
          {{ "quoteCart.cancelButtonText" | cxTranslate }}
        </button>
      </div>
      <div class="col-md-6 save-btn-holder">
        <button 
          (click)="doneEditProduct();"
          class="vs-tertiary-btn save-btn"
        >
          {{ "quoteCart.saveChangeBtn" | cxTranslate }}
        </button>
      </div>
    </div>
  </div>
</div>
